import React from 'react';
import { Select } from 'antd';
import FormItem from '../FormItem/FormItem';

const SelectField = ({
  form,
  items,
  label,
  name,
  renderAction,
  decoratorOptions = {},
  renderOption,
  fieldProps = {},
  ...props
}) => {
  const { getFieldDecorator } = form;
  const hasAction = typeof renderAction === 'function';

  return (
    <FormItem
      {...props}
      hasAction={hasAction}
      label={label}
    >
      {getFieldDecorator(
        name,
        decoratorOptions
      )(
        <Select
          {...fieldProps}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          {items?.map(renderOption)}
        </Select>
      )}
      {hasAction && renderAction()}
    </FormItem>
  );
};

export default SelectField;
